var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAgentAdminMap)?_c('agent-map'):_c('agent-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }